import { createSlice, configureStore } from '@reduxjs/toolkit';

const initialVisualizerState = { 
    surfaceList : [],
    specifier:"",
    selString:"",
    activePackageId:"",
    packagesData:{},
};

const visualizerSlice = createSlice({
  name: "visualizer",
  initialState: initialVisualizerState,
  reducers: {
    // Visualizer base states
    setSurfaceList(state, action) {
      state.surfaceList = action.payload;
    },
    setSpecifier(state, action) {
      state.specifier = action.payload;
    },
    setSelString(state, action) {
      state.selString = action.payload;
    },
    // Set active package
    setActivePackage(state, action){
      state.activePackageId = action.payload;
    }, 
    // Set package data
    setPackageData(state, action){
      state.packagesData = action.payload;
    },

    


  },
});


const initialUIState = {
  toolName:"Cambridge Homes Visualizer Tool",
  vizLoading: false,
  popUpModalActive : false,
  shareModalActive : false,
  emailModalActive : false,
  marketingModalActive : false,
  moreInfoModalActive : false,
  socialShareText : "Checkout out this design I made using the Cambridge Homes visualizer tool!",

  sceneModalActive:false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: initialUIState,
  reducers: {
    setToolName(state, action) {
      state.toolName = action.payload;
    },
    setVizLoading(state, action) {
      state.vizLoading = action.payload;
    },
    setShareModalActive(state, action){
      state.shareModalActive = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    },
    setPopUpModalActive(state, action){
      state.popUpModalActive = action.payload;
    },
    setEmailModalActive(state, action){
      state.emailModalActive = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    },

    setPopUpModalStatus(state, action){
      state.showPopUpModal = action.payload;
    },
    setEmailShareModalStatus(state, action){
      state.showEmailShareModal = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    },
    setMoreInfoModalStatus(state, action){
      state.moreInfoModalActive = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    },

    setMarketingModalStatus(state, action){
      state.marketingModalActive = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    },

    setSceneModalActive(state, action){
      state.sceneModalActive = action.payload;
      if(!action.payload) state.popUpModalActive = false;
    }

  },
});


const store = configureStore({
  reducer: {
    visualizer: visualizerSlice.reducer,
    ui: uiSlice.reducer
  }
});

export const visualizerActions = visualizerSlice.actions;
export const uiActions = uiSlice.actions;

export default store;